import type { NavigateFunction } from 'react-router-dom';

import type { AuthenticationIds } from 'hb-builder/types/config/AuthenticationIds';
import type { DataTypeSelector } from 'hb-builder/utils/dynamicSelectorsHelpers';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';
import type { APP_TYPE } from 'hb-react/types/appType';

export type FieldAttributes =
  | 'displayAttendees'
  | 'displayDate'
  | 'displayDescription'
  | 'displayImage'
  | 'displayLocation'
  | 'displayOnlineEvent'
  | 'displayTags'
  | 'displayTextLink'
  | 'displayTitle';

type FieldsAttributes = {
  [key in FieldAttributes]: boolean;
};

interface QueryAttributes {
  dataType: DataTypeSelector;
  numberOfItems: number;
  categories?: { label: string; value: string }[];
}

interface ButtonAttributes {
  display: boolean;
  newPage: boolean;
}

export interface ListLayoutsDynamicAttributes {
  button: ButtonAttributes;
  fields: FieldsAttributes;
  query: QueryAttributes;
  singleLine: boolean;
  type: LIST_TYPES;
}

export interface ListProps {
  app: APP_TYPE;
  dynamicAttributes?: ListLayoutsDynamicAttributes;
  ids?: AuthenticationIds;
  isPublic: boolean;
  item: DocumentItem<ListItemAttributes> & {
    buttonContent: string;
  };
  navigate?: NavigateFunction;
  networkRootUrl?: string | null;
  type: LIST_TYPES;
  whiteLabelUrl?: string | null;
}

export enum LIST_TYPES {
  EVENTS = 'events',
  NEWS = 'news',
  TOPICS = 'topics',
  EMPTY = 'empty',
}

export interface ListItemAttributes extends SectionItemAttributes {
  buttonLink?: string;
  dynamicAttributes: ListLayoutsDynamicAttributes;
}
